import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FRACCIONES_CON_PLANO } from './PlanoInteractivo';

export default function SeleccionFraccion() {
    const navigate = useNavigate();
    const [fracciones, setFracciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFracciones = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                const userParam = user ? `?user=${user.user_usuario}` : '';
				const response = await fetch(`${API_BASE_URL}/api/fracciones${userParam}`);
                //const response = await fetch('http://192.168.0.3:3001/api/fracciones');
                if (!response.ok) {
                    throw new Error('Error al obtener las fracciones');
                }
                const data = await response.json();
                setFracciones(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchFracciones();
    }, []);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl text-gray-600">Cargando fracciones...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 p-4 rounded-lg">
                <div className="text-red-700">Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-gray-800">Seleccione una Fracción</h2>
                <button
                    onClick={() => navigate('/mis-reservas')}
                    className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                    Mis Reservas
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {fracciones.map(fraccion => (
                    <div 
                        key={fraccion.id_fraccion}
                        onClick={() => navigate(`/manzanas/${fraccion.id_fraccion}`)}
                        className="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-all"
                    >
                        <h3 className="text-lg font-semibold text-gray-800">
                            {fraccion.nombre_fraccion}
                        </h3>
                        
                        <div className="flex items-center mt-2 text-gray-600">
                            <span>📍 {fraccion.ciudad_fraccion}</span>
                        </div>
                        
                        <div className="mt-3 flex items-center justify-between">
                            <span className="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                                {fraccion.estado_fraccion}
                            </span>

                            {FRACCIONES_CON_PLANO.includes(fraccion.id_fraccion) && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(`/plano/${fraccion.id_fraccion}`);
                                    }}
                                    className="px-3 py-1.5 text-sm bg-[#2f62ab] text-white rounded-lg hover:bg-blue-800"
                                >
                                    🗺️ Ver plano interactivo
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}